import { graphql } from "relay-runtime"

export const deRejectPatientAsPotentialDuplicateMutation = graphql`
  mutation deRejectPatientAsPotentialDuplicateMutation($input: De_rejectPatientAsPotentialDuplicateInput!) {
    rejectPatientAsPotentialDuplicate: de_rejectPatientAsPotentialDuplicate(input: $input) {
      boolean
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
